import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { EMPTY, Subject } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { CourierRepo } from 'src/app/core/repositories/courier.repo';
import { DataState } from 'src/app/shared/data-state/data-state';
import { OrderPreviewData } from '../../../../order-preview.component';

@Component({
  selector: 'app-qr-code',
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.scss'],
})
export class QrCodeComponent implements OnInit {
  private readonly destroyed$: Subject<void> = new Subject();
  readonly DataState: typeof DataState = DataState;

  @Input({ required: true }) data!: OrderPreviewData;
  imagePath!: SafeResourceUrl;
  dataState!: DataState;

  constructor(
    private courierRepo: CourierRepo,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.dataState = DataState.Loading;
    this.courierRepo.getPaymentQrByOrderId(this.data.order.id)
      .pipe(
        takeUntil(this.destroyed$),
        catchError(() => {
          this.dataState = DataState.Error;
          return EMPTY;
        }),
      )
      .subscribe(paymentQr => {
        this.imagePath = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + paymentQr.image);
        this.dataState = DataState.None;
      })
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
